import { render } from "./ExpandableText.vue?vue&type=template&id=14a96f38&scoped=true"
import script from "./ExpandableText.vue?vue&type=script&lang=js"
export * from "./ExpandableText.vue?vue&type=script&lang=js"

import "./ExpandableText.vue?vue&type=style&index=0&id=14a96f38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a96f38"]])

export default __exports__